import React from 'react';
import styled from '@emotion/styled';
import numeral from 'numeral';
import { getCurrencySymbol } from '../../../../helpers';

const Wrapper = styled('tr')`
  border-bottom: 1px solid #dee2e6;
`;

const TableRow = (props) => {
  const { item } = props;

  return (
    <>
      <Wrapper>
        <td>{item.num}</td>
        <td colSpan="3">
          {item.title}
          {item.description && <div className="text-muted">{item.description}</div>}
        </td>
        <td className="right" style={{ whiteSpace: 'nowrap' }}>
          {item.amount}
        </td>
        <td>{item.measure}</td>
        <td className="right" style={{ whiteSpace: 'nowrap' }}>{`${numeral(+item.price).format(
          '0,0.00',
        )} ${getCurrencySymbol('RUB')}`}</td>
        <td className="bolder right" style={{ whiteSpace: 'nowrap' }}>{`${numeral(
          +item.totalSum,
        ).format('0,0.00')} ${getCurrencySymbol('RUB')}`}</td>
      </Wrapper>
    </>
  );
};

export default TableRow;
